import {MutationTree} from "vuex";
import * as moment from "moment";
import Client from '../ts/Client';

export const mutations: MutationTree<any> = {

    setClientsLoading(state: any, payload: any) {
        state.clientsLoading = payload;
    },

    setClients(state: any, payload: any) {
        state.clientsCacheExpires = moment().add(15, 'minutes');
        state.clients = payload;
    },

    deleteClient(state: any, id: Number) {
        let index = state.clients.findIndex((client: Client) => client.id === id);
        state.clients.splice(index, 1);
    },

    updateClient(state: any, client: Client) {
        let found = state.clients.find((c: Client) => client.id === c.id);

        if (found) {
            found = Object.assign(found,client);
        }
    },

    createClient(state: any, client: Client) {
        state.clients.push(client);
    }
};
